module.exports = __webpack_public_path__ + "img/smart__face.390b4ecc.svg";